export class ComplianceControlTrends {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "entries",
            "baseName": "entries",
            "type": "Array<ControlTrendEntry>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ComplianceControlTrends.attributeTypeMap;
    }
    constructor() {
    }
}
